import { Col, Form, Row } from 'antd'
import PropTypes from 'prop-types'
import React from 'react'
import Text from 'components/Text'
import { useTranslation } from 'react-i18next'

const DraftDifferenceSection = ({ getDifferenceIfValid }) => {
  const { t } = useTranslation()

  return (
    <div className="vessel-drafts-table__section">
      <Text className="vessel-drafts-table__section-title">
        {t('portCall.draftSurvey.difference')}
      </Text>

      <Row gutter={12}>
        <Col span={8}>
          <div className="vessel-drafts-table__difference-item">
            <Text className="vessel-drafts-table__difference-label">
              {t('portCall.draftSurvey.forward')}
            </Text>
            <Form.Item noStyle shouldUpdate>
              {() => {
                const diffValue = getDifferenceIfValid(
                  ['visual', 'forward'],
                  ['calculated', 'forward']
                )

                return (
                  <Text className="vessel-drafts-table__difference-value">
                    {diffValue !== ''
                      ? `${diffValue} ${t('portCall.draftSurvey.m')}`
                      : ''}
                  </Text>
                )
              }}
            </Form.Item>
          </div>
        </Col>

        <Col span={8}>
          <div className="vessel-drafts-table__difference-item">
            <Text className="vessel-drafts-table__difference-label">
              {t('portCall.draftSurvey.midship')}
            </Text>
            <Form.Item noStyle shouldUpdate>
              {() => {
                const diffValue = getDifferenceIfValid(
                  ['visual', 'midship'],
                  ['calculated', 'midship']
                )

                return (
                  <Text className="vessel-drafts-table__difference-value">
                    {diffValue !== ''
                      ? `${diffValue} ${t('portCall.draftSurvey.m')}`
                      : ''}
                  </Text>
                )
              }}
            </Form.Item>
          </div>
        </Col>

        <Col span={8}>
          <div className="vessel-drafts-table__difference-item">
            <Text className="vessel-drafts-table__difference-label">
              {t('portCall.draftSurvey.aft')}
            </Text>
            <Form.Item noStyle shouldUpdate>
              {() => {
                const diffValue = getDifferenceIfValid(
                  ['visual', 'aft'],
                  ['calculated', 'aft']
                )

                return (
                  <Text className="vessel-drafts-table__difference-value">
                    {diffValue !== ''
                      ? `${diffValue} ${t('portCall.draftSurvey.m')}`
                      : ''}
                  </Text>
                )
              }}
            </Form.Item>
          </div>
        </Col>
      </Row>
    </div>
  )
}

DraftDifferenceSection.propTypes = {
  getDifferenceIfValid: PropTypes.func.isRequired,
}

export default DraftDifferenceSection
